<template>
  <div class="widthBox">
    <h1 class="title txt_left mt_80 mb_40 cursor" @click="query.p_type_id = '';query.page = 1;get_info()">{{ $t("All Products") }} </h1>
    <div class="product_class mb_40 " ref="product_class">
        <div v-for="(item,index) in products_type" :key="index" class="class_item info3 f-20 cursor radius-4" :class="query.p_type_id==item.id ? 'warn_txt' : ''" @click.stop="set_id(item.id)">
            {{item.name}}
        </div>
    </div>
    <div class="list">
        <el-row :gutter="gutter" class="acea-row mb_40">
            <el-col :md="8" :xs="12" :sm="12" v-for="(item,index) in product_list" :key="index" class="mt_40 cursor">
                <router-link :to="'/Products_details?id='+item.id">
                    <div class="image">
                        <img :src="item.thumbnail_url" class="img100 radius-8" alt="">
                    </div>
                    <h2 class="info f-20 mt_20 line_Hide_1">{{ item.name }}</h2>
                    <h3 class="info2 f-16 mt_8 line_Hide_1">{{ item.desc }}</h3>
                    <p class="txt f-20 mt_16" v-if=" item.sku">${{ item.sku.price }}</p>
                    <p class="btn mt_16 hidden-xs-only">{{ $t("see more") }}</p>
                </router-link>
            </el-col>
        </el-row>
    </div>
    <div class="txt_center pageBox">
      <el-pagination
        background
        hide-on-single-page
        layout="prev, pager, next"
        :page-count="count"
        @current-change="change"
        >
      </el-pagination>
    </div>
</div>
</template>

<script>
import Drag from '../../utils/move';
export default {
    name:"Products_index",
    data(){
        return {
            query:{
                p_type_id:0,
                page:1,
                limit:3
            },
            count:1,
            products_type:[],
            product_list:[],
            gutter:60
        }
    },
    created(){
        this.query.p_type_id = this.$route.query.id;
        this.get_info();
        if(window.innerWidth < 750){
            this.gutter = 11
        }
    },
    mounted(){
        new Drag(this.$refs.product_class)
    },
    watch: {
        $route: {
            handler(to, from) {
                this.query.p_type_id = this.$route.query.id;
                this.query.page = 1;
                this.get_info();
            },
            deep:true
        }
    },
    methods:{
        set_id(p_type_id){
            this.query.p_type_id = p_type_id
            this.query.page = 1;
            this.get_info();
        },
        change(e){
            this.query.page = e;
            this.get_info();
        },
        async get_info(){
            let res = await this.$api.get("api/Products/list", this.query);
            this.product_list = res.data.goods_list.list;
            this.count = res.data.goods_list.pages
            this.products_type = res.data.type_list;
        }
    }
}
</script>

<style lang="scss" scoped="scoped">
.image{
    position: relative;
    width: 100%;
    height: 0px;
    padding-top: 100%; //padding-bottom都可以
    img{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}
.mt_80{
    margin-top: 80px;
}
.mb_40{
    margin-bottom: 40px;
}
.mt_40{
    margin-top: 40px;
}
.mt_20{
    margin-top: 20px;
}
.mt_8{
    margin-top: 8px;
}
.mt_16{
    margin-top: 16px;
}
.product_class{
    padding: 40px;
    box-sizing: border-box;
    display: flex;
    background: #f5f5f5;
    border-radius: 8px;
    overflow: auto;
    overflow-x: hidden;
    white-space: nowrap;
    .class_item{
        margin-right: 80px;
    }
}
.list{
    border-top: 1px solid #e6e6e6;
    box-sizing: border-box;
    text-align: center;
    h2,h3{
        padding: 0 45px;
        box-sizing: border-box;
    }
    .btn{
        display: block;
        padding: 16px 0;
        border-radius: 27px;
        border: 1px solid #b50900;
        color: #b50900;
        font-size: 14px;
        text-align: center;
    }
}
@media screen and(max-width:768px) {
    .mt_80{
        margin-top: 40px;
    }
    .mb_40{
        margin-bottom: 20px;
    }
    
    .mt_20{
        margin-top: 12px;
    }
    .mt_8{
        margin-top: 8px;
    }
    .mt_16{
        margin-top: 8px;
    }
    .product_class{
        background: none;
        padding: 0;
        border-radius: 0px;
        .class_item{
            padding: 8px 16px;
            box-sizing: border-box;
            margin-right: 32px;
        }
    }
    .list{
        h2,h3{
            padding: 0px;
            box-sizing: border-box;
        }
        text-align: left;
        
        .info{
            font-size: 14px !important;
        }
        .info2{
            font-size: 12px !important;
        }
        .txt{
            font-size: 20px;
            color: #b50900;
        }
    }
    .warn_txt{
        color: #Fff;
        background: #b50900;
    }
}
</style>